import "../../styles/financePage.scss";
import TransactionModal from "../../containers/Modals/TransactionModal";
import FinanceAnnualSummaryCharts from "../../containers/FinanceAnnualSummaryCharts";
import { useState } from "react";
import TransactionsByFilter from "../../containers/Tables/TransactionsByFilter";

const MainFinancePage = () => {
  const [modalsData, setModalsData] = useState({
    transactionModalId: null,
    transactionModalShow: false,
  });

  return (
    <div className="content finance-stats">
      <div className="d-flex align-items-center gap-4">
        <h1>Finanzas - Estadisticas</h1>
      </div>
      <FinanceAnnualSummaryCharts />

      <TransactionsByFilter setModalsData={setModalsData} />

      <TransactionModal
        show={modalsData.transactionModalShow}
        onHide={() => {
          // fetchTransactionsByFilter();
          setModalsData({
            ...modalsData,
            transactionModalId: null,
            transactionModalShow: false,
          });
        }}
        transactionId={modalsData.transactionModalId}
      />
    </div>
  );
};

export default MainFinancePage;
